import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class BimNotificationService {
  private bimAndPlanViewerReadySubject = new BehaviorSubject<boolean>(null);
  public bimAndPlanViewerReady$ = this.bimAndPlanViewerReadySubject.asObservable();

  public notifyBimAndPlanViewerReady() {
    this.bimAndPlanViewerReadySubject.next(true);
  }
}
